import React, { useState, useEffect } from "react";
import { getOptionsData } from "../../utils/app.utils";
import { useQuery } from "@tanstack/react-query";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
} from "@mui/material";

export default function SingleChoice({ question, value, onChange }: any) {
  const [selected, setSelected] = useState(value ?? "");
  const [options, setOptions] = useState<any[]>([]);

  const { data: optionsData = [], isLoading } = useQuery({
    queryKey: ["options", question?.id],
    queryFn: () => getOptionsData(question?.id),
  });

  useEffect(() => {
    if (optionsData.length) {
      setOptions(optionsData);
    }
  }, [optionsData]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelected(e.target.value);
    onChange?.(e.target.value);
  };

  return (
    <FormControl sx={{ marginTop: 1 }}>
      <RadioGroup
        name={`single-choice-${question.id}`}
        value={selected}
        onChange={handleChange}
      >
        {options.map((opt: any) => (
          <FormControlLabel
            key={opt.id}
            value={opt.id.toString()}
            control={<Radio />}
            label={opt.name}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
